
/**
 * Component for global text input
 * @param props 
 * @returns JSX.Element
 */
export default function TextInput(props : any) {
  return <input style={{width: "300px"}} type="text" className="form-control" {...props} />
}
